<template lang='pug'>
  modal-wrapper.max-640( @close='$emit("close")' )
    template( v-slot:header )
      h3 
        slot( name='header' ) {{ $t('New Service') }}

    template( v-slot:contents )
      form.set-service.component( ref='form' @submit.prevent='set' )
        bf-input.basic.labeled(:text='service.title')
          template(v-slot:label) {{ $t("Product or Service Name") }}
          input(
            required
            type='text'
            :placeholder='$t("Product or Service Name")'
            v-model='service.title'
          )

        bf-input.basic
          select( v-model='service.category_id' :class='{ selected: service.category_id != "label" }' @change='categorize' )
            option( value='' ) {{ $t('Category') }}
            option( v-for='category in categories' :value='category.id' ) {{ category.title }}
            option( value='add' ) {{ $t('Add Category') }}

        bf-input
          template( v-slot:icon )
            money-icon
          input(
            type='number'
            step='0.01'
            :placeholder='$t("Price")'
            v-model='service.price'
          )

        label {{$t("Duration in minutes")}}
        bf-input.icon-right
          template(v-slot:icon)
            span {{ $t('mins') }}
          input(
            required
            type='number'
            step=5
            value=30
            v-model='service.duration'
          )
        label {{$t("Enter a Description")}}
        textarea( v-model='service.description' :text='service.description')
        
        label {{$t("Special ordering instructions")}}
        textarea( v-model='service.instructions' :text='service.instructions')

        input(type='file' ref='upload' style='display: none' accept='image/*' @change='upload($event, images)' multiple)
        sortable.sortable.thumbs(
          v-model='images'
          handle='.image-container'
        )
          template(v-slot:header)
            bf-flex.upload-container.centered(@click.native='$refs.upload.click()')
              .icon
                new-icon
              span {{ $t('Add Photo') }}

          .image-container(v-for='image, i in images' :key='`image-${i}-${image.id}`')
            .delete(@click='del(image, i)')
              delete-icon
            bf-flex.centered.draggable
              draggable-icon
            img(:src='image.src')

        bf-divider.borderless.section

        H5 {{$t("Upload information about your service")}}:
        input(type='file' ref='files' style='display: none' accept='application/pdf' @change='populate' multiple)
        sortable.sortable.files(
          v-model='files'
          handle='.file-container'
        )
          template(v-slot:header)
            bf-flex.upload-container.centered(@click.native='$refs.files.click()')
              .icon
                new-icon
              span {{ $t('Add File') }}

          .image-container.file-container(v-for='file, i in files' :key='`file-${i}-${file.id}`')
            .delete(@click='del(file, i, "files")')
              delete-icon
            bf-flex.centered.draggable
              draggable-icon
            img( src='/pdf.png' )
            .title
              input( v-model='file.title' type='text' placeholder='Title' )

        button.hidden( type='submit' ref='save' )

    template( v-slot:footer )
      .form-buttons
        bf-button( type='submit' @click.native='$refs.save.click()' )
          template(v-slot:text) {{ $t('Save') }}
</template>

<script>
  import Sortable from 'vuedraggable'
  import { db, str } from '@/main'
  import ModalWrapper from '@/components/modals/wrapper'

  export default {
    name: 'set-service.component',

    props: {
      biz: { required: true },
      categories: Array,
      settable: { type: Object, default: () => ({}) },
      account: Object,
      add: Boolean
    },

    components: {
      Sortable,
      ModalWrapper
    },

    data() {
      return {
        key: 0,
        service: {},
        images: [],
        files: []
      }
    },

    firestore() {
      if ( this.settable.id ) return {
        images: db.collection( 'services' ).doc( this.settable.id ).collection( 'images').orderBy('index'),
        files: db.collection( 'services' ).doc( this.settable.id ).collection( 'files').orderBy('index')
      }
    },

    methods: {
      populate( e ) {
        this.files = this.files.concat( Array.from( e.target.files ) )
      },

      categorize( e ) {
        if ( this.service.category_id == 'add' ) this.$emit( 'categorize' )
      },

      upload( e, images ) {
        Array.from( e.target.files ).forEach( file => {
          let reader  = new FileReader()
          reader.addEventListener('load', () => {
            const name = file.name
            let img = new Image()
            img.src = reader.result
            img.onload = () => {
              let width = img.width
              let height = img.height
              let ratio = img.width / img.height
              if( img.width > 800 ) {
                width = 800
                height = width / ratio
              }
              else if ( img.height > 800 ) {
                height = 800
                width = height * ratio
              }
              const elem = document.createElement('canvas')
              elem.width = width
              elem.height = height
              const ctx = elem.getContext('2d')
              ctx.drawImage( img, 0, 0, width, height )
              ctx.canvas.toBlob( blob => {
                const file = new File([blob], name, {
                  type: 'image/jpeg',
                  lastModified: Date.now()
                })
                images.push({ src: reader.result, file: file })
              }, 'image/jpeg', 1)
            }
            
          }, false)

          reader.readAsDataURL(file)
        })
      },

      set() {
        if ( !this.settable.id ) {
          this.service.business_id = this.biz.id
          db.collection( 'services' ).add( this.service ).then( srv => {
            this.images.forEach( ( image, i ) => {
              let path = `services/${srv.id}/images/${image.file.name}`
              let ref = str.ref( path )
              ref.put( image.file ).then( snap =>
                snap.ref.getDownloadURL().then( url => {
                  srv.collection( 'images' ).add({ src: url, index: i, path: path })
                }).then( () => {
                  this.key++
                })
              ).catch( e => console.log(e) )
            })

            this.files.forEach( ( file, i ) => {
              let path = `services/${srv.id}/files/${file.name}`
              let ref = str.ref( path )
              ref.put( file ).then( snap =>
                snap.ref.getDownloadURL().then( url => {
                  srv.collection( 'files' ).add({ src: url, index: i, path: path })
                }).then( () => {
                  this.key++
                })
              ).catch( e => console.log(e) )
            })

            this.$emit( 'set', 'New Service Added' )
          }).catch( e => this.$emit('error', 'Image size must be less than 1mb') )
        }
        else {
          let doc = db.collection( 'services' ).doc( this.service.id )
          doc.set( this.service, { merge : true } ).then( () => {
            this.images.forEach( (image, i) => {
              if ( image.id ) {
                doc.collection( 'images' ).doc( image.id ).update({ index: i })
              }
              else {
                let path = `services/${this.service.id}/images/${image.file.name}`
                let ref = str.ref( path )
                ref.put(image.file).then( snap =>
                  snap.ref.getDownloadURL().then( url => {
                    console.log('url obtained for new', url)
                    image.src = url
                    doc.collection( 'images' ).add({ src: url, index: i, path: path })
                  })
                ).catch( e => console.log(e) )
              } 
            })

            this.files.forEach( (file, i) => {
              if ( file.id ) doc.collection( 'files' ).doc( file.id ).update({ index: i, title: file.title }).then( this.$emit( 'set', 'Service Updated' ) )
              else {
                let path = `services/${this.service.id}/files/${file.name}`
                let ref = str.ref( path )
                ref.put( file ).then( snap =>
                  snap.ref.getDownloadURL().then( url => {
                    file.src = url
                    doc.collection( 'files' ).add({ src: url, index: i, path: path, title: file.title || '' })
                  })
                ).catch( e => console.log(e) )
              } 
            })

            this.$emit( 'set', 'Service Updated' )
          }).catch( e => this.$emit('error', 'Image size must be less than 1mb') )
        }
      },

      del( target, i, collection='images' ) {
        if ( this.settable.id )
          db.collection( 'services' ).doc( this.service.id ).collection( collection ).doc( target.id ).delete()
        else
          this[collection].splice( i, 1 )
      }
    },

    created() {
      if ( this.settable.id ) this.service = this.settable
      else this.service = { category_id: '' }
    }
  }
</script>

<style scoped lang='stylus'>
  textarea
    border solid 1px rgba(0 0 0 0.1)
    border-radius 5px
    padding 8px
    margin-bottom 10px
    width 97.5%
  .sortable
    display grid
    grid-template-columns repeat( auto-fill, minmax( 96px, 1fr ) )
    grid-gap 1.6vw
    grid-auto-rows 88px
    @media( max-width: 480px )
      grid-template-columns repeat( auto-fill, minmax( 88px, 1fr ) )
      grid-auto-rows 96px
    &.files
      grid-template-columns repeat( auto-fill, minmax( 88px, 1fr ) )
      .image-container
        img
          height calc( 100% - 2em )
          object-fit contain
        input
          text-align center
          position relative
          z-index 1
          border-top 1px solid rgba( 0 0 0 .1 )
          font-size .9em
          width 100%
  .set-service
    min-width 480px
    @media( max-width: 560px )
      min-width 0
    .bf-input
      margin-bottom 16px
      width 100%
      box-sizing border-box
    select
      color inherit
      font-weight normal
      &.selected
        font-weight bold
        color var(--clr-dark)
    .image-container
      border-radius 12px
      overflow hidden
      position relative
      cursor grab
      .delete
        position absolute
        cursor pointer
        top 0
        right 0
        color white
        padding 4px 8px
        background rgba( 0 0 0 .25 )
        border-bottom-left-radius 12px
        z-index 2
      .draggable
        position absolute
        height 100%
        width 100%
        background radial-gradient(circle at center, rgba( 0 0 0 .3) , rgba( 0 0 0 .1 ), rgba( 0 0 0 0 ) 100%)
        border-top-right-radius 12px
        font-size 2em
        color white
        z-index 1
      img
        width 100%
        height 100%
        object-fit cover
    .upload-container
      flex-direction column
      background rgb( 240 240 240 )
      cursor pointer
      border-radius 12px
      height 100%
      width 100%
      .icon
        font-size 2em
      span
        font-size .88em
        font-weight bold
  .form-buttons
    padding 16px
    text-align center
</style>
